Cureus.UserProfile = {
};

//= require_tree ./UserProfile
